export enum BillsActionPoint {
  Handle = 1,
  ClickToUpload = 2,
}
